import React, { useEffect, useState } from "react";
import { Modal, Select, Input, message, Spin, Tabs } from "antd";
import axiosInstance from "../../service/AxiosInstance";
import { useDrawer } from "../layout-components/menu/menuContext";
import useFuzzySearchSelect from "../../hooks/useFuzzySearch";
import WarningModal from "../../screens/valuation/homescreen/WarningModal";
import useValuationWarning from "../../hooks/useValuationWarning";
import "./landing-page.css";
import SearchResults from "./SearchResults";
import RadiusBtn from "../../screens/valuation/PMA/RadiusBtn";
import { fetchBrands, fetchStates } from "../../screens/portfolioApp/portfolio/commonApis";
import CustomDropdownRender from "../SelectDeselect";
import { APP_PREFIX_PATH } from "../../Config/AppConfig";

const { Option } = Select;
const { TabPane } = Tabs;

const InstantReportModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  dealerData,
  selectedDealerId,
  newValuationName,
  setNewValuationName,
  warning,
  setWarning,
  loading,
  setSelectedDealerId,
  setIsModalOpen,
  showOverlay,
  isAnalyticsFlow = false,
}) => {
  const { dispatch } = useDrawer();
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [fixedRadiusInMiles, setFixedRadiusInMiles] = useState(8);
  const [radiusPerMile, setRadiusPerMile] = useState([
    1, 2, 3, 4, 5, 7, 10, 15, 20, 30, 40, 50, 75, 100,
  ]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [brands, setBrands] = useState([]);
  const [dealersZipcode, setDealersZipcode] = useState([]);
  const [zipcodeLoading, setZipcodeLoading] = useState(false);
  const [zipcode, setZipcode] = useState();
  const [states, setStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const handleRadiusMiles = (val) => {
    setFixedRadiusInMiles(fixedRadiusInMiles + val);
    // setPayload({})
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setIsSearchActive(false);
    setZipcode(undefined);
    setFixedRadiusInMiles(8);
    setSelectedBrand([]);
    setSelectedStates([]);
    setWarning(false);
  };

  const handleCancelWithTab = (key) => {
    setActiveTab("1");
    setTimeout(() => setIsSearchActive(false), 300);
    handleCancel();
    setZipcode(undefined);
    setFixedRadiusInMiles(8);
    setSelectedBrand([]);
    setSelectedStates([]);
  };
  const FUSE_OPTIONS = {
    includeScore: true,
    threshold: 0.3,
    ignoreLocation: true,
    useExtendedSearch: true,
    includeMatches: true,
    findAllMatches: true,
    keys: [
      { name: "dealer__name", weight: 10, tokenize: true },
      { name: "state__name", weight: 5 },
      { name: "city__name", weight: 5 },
      { name: "brand__name", weight: 5 },
      { name: "dealer__info", weight: 7, tokenize: true },
    ],
  };

  const {
    searchTerm,
    isPending,
    handleInputChange,
    handleOptionSelect,
    performSearch,
    selectedOption,
  } = useFuzzySearchSelect(dealerData, FUSE_OPTIONS, setSelectedDealerId);
  useEffect(() => {
    setWarning(false);
  }, []);

  const CreateNewValuation = async () => {
    try {
      const { data: response } = await axiosInstance.post(
        `/valuation`,
        {
          dealer_info_id: selectedDealerId,
          name: newValuationName,
          config_id: 1421,
          isInstantReport: true,
          dealer_id: selectedOption,
        },
        {
          params: {
            username: sessionStorage.getItem("user_name"),
          },
        }
      );

      if (response.Status) {
        const valuationId = response.Valuation_id;
        dispatch({ type: "SET_INSTANT_REPORT", value: true });
        handleOk(valuationId);
      } else {
        message.warning(response.Message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const { handleValuation } = useValuationWarning(
    dealerData,
    selectedDealerId,
    newValuationName,
    CreateNewValuation,
    setShowWarningModal,
    setWarningMessage,
    setWarning,
    setIsModalOpen,
    showOverlay
  );
  const handleCreateValuation = () => {
    if (isAnalyticsFlow) {
      if (!selectedDealerId) {
        setWarning(true);
        return;
      }
      // For Analytics flow, navigate to Impact Analysis page with query params
      // setIsModalOpen(false);
      const selectedDealer = dealerData.find(item => item.dealer_info_id === selectedDealerId);
      const dealerName = selectedDealer ? `${selectedDealer.dealer__name}-${selectedDealer.brand__name}-${selectedDealer.city__name}-${selectedDealer.state__name}` : '';
      const queryParams = new URLSearchParams({
        type: 'dealer_statevsbrand',
        dealer_name: dealerName
      }).toString();
      window.open(`/${APP_PREFIX_PATH}/analytics/impact?${queryParams}`, "_blank");
    } else {
      handleValuation();
    }
  };

  const handleCreateValuation1 = () => {
    if (isAnalyticsFlow) {
      // Validation for analytics flow
      if (!selectedStates || (Array.isArray(selectedStates) && selectedStates.length === 0)) {
        setWarning(true);
        return;
      }
      
      // For Analytics flow, navigate to Impact Analysis page with query params
      // setIsModalOpen(false);
      const queryParams = new URLSearchParams({
        type: 'statevsbrand',
        state: selectedStates,
        brand: selectedBrand.join(',')
      }).toString();
      window.open(`/${APP_PREFIX_PATH}/analytics/impact?${queryParams}`, "_blank");
    } else {
      // For regular flow
      if (!zipcode && !selectedStates.length) {
        setWarning(true);
      } else {
        setIsSearchActive(true);
      }
    }
  };

  const fetchDealersNZipCode = async () => {
    setZipcodeLoading(true);
    try {
      const { data } = await axiosInstance.get(
        `/dealership_zipcode_suggestions`
      );
      setDealersZipcode(data);
      // sessionStorage.setItem("zip_dealers", JSON.stringify(data));
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setZipcodeLoading(false);
    }
  };

  const handlePrevious = () => {
    setIsSearchActive(false);
    setZipcode("");
    setFixedRadiusInMiles(8);
    setSelectedBrand([]);
    setSelectedStates([]);
  };

  const fetchBrandsList = async () => {
    const brandsList = await fetchBrands();
    setBrands(brandsList);
  };

  const fetchStatesList = async () => {
    setStatesLoading(true);
    try {
      const statesList = await fetchStates();
      setStates(statesList);
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setStatesLoading(false);
    }
  };

  useEffect(() => {
    const dealersZipcode_ = JSON.parse(sessionStorage.getItem("zip_dealers"));
    if (dealersZipcode_) {
      setDealersZipcode(dealersZipcode_);
    } else {
      fetchDealersNZipCode();
    }
    fetchBrandsList();
    fetchStatesList();
  }, []);
  const handlePostValuationAction = (valuationId) => {
    dispatch({ type: "SET_INSTANT_REPORT", value: true });
  };

  return (
    <>
      <Modal
        className="fin_modall"
        title={
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            className="tabs-head"
          >
            <TabPane
              className="left-tab"
              closable
              tabKey="3213"
              tab={isAnalyticsFlow ? "State-Dealership vs Brand Impact" : "Create Instant Report"}
              key="1"
            />
            <TabPane tab={isAnalyticsFlow ? "State vs Brand Impact" : "Advanced Search"} key="2" />
          </Tabs>
        }
        width={isSearchActive ? 1450 : 500}
        open={isModalOpen}
        okText="Next"
        cancelText="Cancel"
        onOk={activeTab == 1 ? handleCreateValuation : handleCreateValuation1}
        // onOk={handleCreateValuation1}
        onCancel={handleCancelWithTab}
        footer={isSearchActive ? null : undefined}
      >
        {isSearchActive ? (
          <SearchResults
            onPrevious={handlePrevious}
            initialZipcode={zipcode}
            initialBrand={selectedBrand}
            initialRadius={radiusPerMile[fixedRadiusInMiles]}
            handleOk={handleOk}
            handlePostValuationAction={handlePostValuationAction}
            AllDealerData={dealerData}
            setIsModalOpen={setIsModalOpen}
            showOverlay={showOverlay}
          />
        ) : activeTab === "1" ? (
          <div>
            <div className="top_label_wrapper">
              <label htmlFor="home_screen_new_val_drop_down">
                Select a Dealership<span style={{ color: "#db0d0d" }}>*</span>
              </label>
            </div>
            <Spin spinning={loading}>
              <Select
                id="home_screen_new_val_drop_down"
                className="date_picker_drop_down"
                showSearch
                allowClear
                style={{ width: "100%" }}
                placeholder="-"
                value={selectedDealerId ? selectedDealerId : undefined}
                optionFilterProp="children"
                onChange={handleOptionSelect}
                filterOption={false}
                onSearch={handleInputChange}
              >
                {isPending ? (
                  <Option value="" disabled>
                    Loading...
                  </Option>
                ) : (
                  dealerData &&
                  performSearch(searchTerm).map((item) => (
                    <Option key={item.dealer_id} value={item.dealer_info_id}>
                      {item.dealer__name}-{item.brand__name}-{item.city__name}-{item.state__name}
                    </Option>
                  ))
                )}
              </Select>
              {!selectedDealerId && warning && (
                <span className="danger">Dealer Name is mandatory</span>
              )}
              <br />
              <label htmlFor="home_screen_new_val_uation">
                Instant Report Name<span style={{ color: "#db0d0d" }}>*</span>
              </label>
              <Input
                id="home_screen_new_val_uation"
                value={newValuationName}
                className="home_screen_search"
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  if (value.length <= 75) {
                    setNewValuationName(value);
                  }
                }}
                maxLength={75}
                placeholder="Enter the Report Name here"
              />
              {!newValuationName && warning && (
                <span className="danger">Instant Report Name is mandatory</span>
              )}
              {newValuationName && newValuationName.length === 75 && (
                <span className="danger">Report Name cannot exceed 75 characters</span>
              )}
            </Spin>
          </div>
        ) : (
          <div>
            <p>Fill in one or more fields</p>
            <div className="top_label_wrapper">
              <label htmlFor="zipcode_select">
                {isAnalyticsFlow ? "State" : "Zipcode or Dealership"}
                <span style={{ color: "#db0d0d" }}>*</span>
              </label>
            </div>
            {isAnalyticsFlow ? (
              <>
                <Select
                  id="state_select"
                  loading={statesLoading}
                  className="date_picker_drop_down"
                  placeholder="Select"
                  style={{ width: "100%" }}
                  showSearch
                  disabled={statesLoading}
                  onChange={setSelectedStates}
                  value={selectedStates}
                >
                  {states?.map((state, index) => (
                    <Option key={index} value={state.Name}>
                      {state.Name}
                    </Option>
                  ))}
                </Select>
                {(!selectedStates || (Array.isArray(selectedStates) && selectedStates.length === 0)) && warning && (
                  <span className="danger">State is mandatory</span>
                )}
              </>
            ) : (
              <>
                <Select
                  id="zipcode_select"
                  loading={zipcodeLoading}
                  className="date_picker_drop_down"
                  style={{ width: "100%" }}
                  placeholder="Select"
                  onChange={setZipcode}
                  value={zipcode}
                  showSearch={true}
                  disabled={zipcodeLoading}
                  // suffixIcon={suffix}
                >
                  {dealersZipcode.map((brand, index) => (
                    <Option key={index} value={brand.Name}>
                      {brand.Name}
                    </Option>
                  ))}
                </Select>
                {!zipcode && warning && (
                  <span className="danger">Zipcode is mandatory</span>
                )}
              </>
            )}

            {/* <br /> */}
            <div className="top_label_wrapper">
              <label htmlFor="state_select">
                {isAnalyticsFlow ? "Brand" : "Brand(s)"}
              </label>
            </div>
            <Select
              id="state_select"
              // loading={brandLoading}
              placeholder="Select"
              className="advance_brand"
              style={{ width: "100%", height: "40px" }}
              onChange={(value) => {
                if (isAnalyticsFlow) {
                  setSelectedBrand(value ? [value] : []);
                } else {
                  setSelectedBrand(value);
                }
              }}
              value={isAnalyticsFlow ? (selectedBrand.length > 0 ? selectedBrand[0] : undefined) : selectedBrand}
              showSearch={true}
              mode={isAnalyticsFlow ? undefined : "multiple"}
              // disabled={brandLoading}
              dropdownRender={(menu) => (
                isAnalyticsFlow ? menu : (
                  <CustomDropdownRender
                    menu={menu}
                    onToggleAll={() => {
                      if (!isAnalyticsFlow) {
                        const allBrandsSelected =
                          selectedBrand.length === brands.length;
                        setSelectedBrand(
                          allBrandsSelected ? [] : brands.map((brand) => brand.name)
                        );
                      }
                    }}
                  />
                )
              )}
            >
              {brands.map((brand) => (
                <Option key={brand.id} value={brand.name}>
                  {brand.name}
                </Option>
              ))}
            </Select>

            {!isAnalyticsFlow && (
              <>
                <div className="top_label_wrapper">
                  <label htmlFor="radius_select">
                    Current Radius <span style={{ color: "#db0d0d" }}>*</span>
                  </label>
                </div>
                <RadiusBtn
                  radiusPerMile={radiusPerMile}
                  handleRadiusMiles={handleRadiusMiles}
                  fixedRadiusInMiles={
                    radiusPerMile && radiusPerMile[fixedRadiusInMiles]
                  }
                  color="#1D5E5C"
                />
              </>
            )}
            <br />
          </div>
        )}
      </Modal>
      {showWarningModal && (
        <WarningModal
          visible={showWarningModal}
          onClose={() => setShowWarningModal(false)}
          messageContent={warningMessage}
          onCreateValuation={CreateNewValuation}
          // brandDataSource={dealer?.dealer__is_brand_data_source}
          // stateDataSource={dealer?.dealer__is_state_data_source}
        />
      )}
    </>
  );
};

export default InstantReportModal;
